/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { SetActiveDataReports } from '../../../reports/state/report.actions';

export class DataReportCommand extends MapCommand {

    invoke() {
        this.deps['store'].dispatch(new SetActiveDataReports());
        this.deactivate$.next();
    }
}
